import React, { useEffect, useState } from "react";
import { Modal, Form, Button, Spinner, Alert, InputGroup } from "react-bootstrap";
import * as cobrosFamiliaApi from "../../api/cobrosFamilia";
import { formatoNumero } from "../../utils/moneda";

/** Registra un abono parcial (amortización) sobre el saldo pendiente de un cobro. */
export default function ModalAmortizarCobro({ show, onHide, cobro, onGuardado }) {
  const [monto, setMonto] = useState("");
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (show) { setMonto(""); setError(""); }
  }, [show]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setGuardando(true);
    try {
      await cobrosFamiliaApi.amortizar(cobro.cobroId, Number(monto));
      onGuardado();
    } catch (err) {
      setError(err.response?.data?.mensaje || "No se pudo registrar el abono.");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "1.1rem" }}>Amortizar cobro</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {error && <Alert variant="danger" dismissible onClose={() => setError("")}>{error}</Alert>}
          <p className="text-muted">
            {cobro?.deudor} — <strong>{cobro?.descripcion}</strong>
          </p>
          <p>Saldo pendiente: <strong className="text-fs-gasto">${formatoNumero(cobro?.saldoPendiente)}</strong></p>
          <Form.Group>
            <Form.Label>Monto a abonar</Form.Label>
            <InputGroup>
              <InputGroup.Text>$</InputGroup.Text>
              <Form.Control type="number" step="0.01" min="0.01" max={cobro?.saldoPendiente} value={monto} onChange={(e) => setMonto(e.target.value)} required autoFocus />
            </InputGroup>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={onHide}>Cancelar</Button>
          <Button type="submit" variant="primary" disabled={guardando}>
            {guardando ? <Spinner size="sm" animation="border" /> : "Abonar"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
